webpackJsonp([150230717460931],{

/***/ 311:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(311);
	
	var _gatsbyImage = __webpack_require__(141);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _reactHelmet = __webpack_require__(4);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactMarkdown = __webpack_require__(69);
	
	var _reactMarkdown2 = _interopRequireDefault(_reactMarkdown);
	
	var _ButtonSquare = __webpack_require__(11);
	
	var _TechnologiesBlock = __webpack_require__(51);
	
	var _TechnologiesBlock2 = _interopRequireDefault(_TechnologiesBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Article = function Article(props) {
	  var data = props.data;
	
	  var article = data.datoCmsArticle;
	  var pictures = article.pictures,
	      articleType = article.articleType,
	      technologies = article.technologies,
	      link = article.link,
	      linkText = article.linkText;
	
	  var theme = articleType === 'article' ? 'light' : 'dark';
	  var picturesDivs = [];
	  pictures.forEach(function (picture) {
	    picturesDivs.push(_react2.default.createElement(_gatsbyImage2.default, { key: picture.id, sizes: picture.sizes, alt: picture.alt }));
	  });
	  var technos = _react2.default.createElement('div', null);
	  if (technologies && technologies.split(',').length > 1) {
	    technos = _react2.default.createElement(_TechnologiesBlock2.default, { technologies: technologies.split(',') });
	  }
	  return _react2.default.createElement(
	    'div',
	    { className: 'article_background_' + theme + ' view_article' },
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: article.title + ' - Com des L\xE9zards'
	      // meta={[
	      //   { name: 'description', content: 'Sample' },
	      //   { name: 'keywords', content: 'sample, something' },
	      // ]}
	    }),
	    _react2.default.createElement(
	      'div',
	      { className: 'article_pictures_container' },
	      picturesDivs
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'article_description_container' },
	      _react2.default.createElement(
	        'h2',
	        null,
	        article.subtitle
	      ),
	      _react2.default.createElement(
	        'h1',
	        null,
	        article.title
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(_reactMarkdown2.default, { source: article.text })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'article_delimiter_container' },
	        _react2.default.createElement('div', { className: 'delimiter' }),
	        _react2.default.createElement(
	          'a',
	          { href: link, rel: 'nofollow' },
	          linkText
	        )
	      ),
	      technos
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'article_return_button' },
	      _react2.default.createElement(_ButtonSquare.ButtonReturn, { theme: theme === 'dark' ? 'light' : 'dark' })
	    )
	  );
	};
	
	Article.defaultProps = {
	  data: {}
	};
	
	Article.propTypes = {
	  data: _propTypes2.default.shape({
	    datoCmsArticle: _propTypes2.default.shape({
	      id: _propTypes2.default.number.isRequired,
	      articleType: _propTypes2.default.string.isRequired,
	      title: _propTypes2.default.string.isRequired,
	      subtitle: _propTypes2.default.string.isRequired,
	      text: _propTypes2.default.string.isRequired,
	      technologies: _propTypes2.default.string.isRequired,
	      link: _propTypes2.default.string.isRequired,
	      linkText: _propTypes2.default.string.isRequired
	    }).isRequired
	  })
	};
	
	exports.default = Article;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-article-article-jsx-7f37b06a4bd562138354.js